// extracted by mini-css-extract-plugin
export default {"login":"login_login__DdzIu","title":"login_title__Y6VOw","login_buttons":"login_login_buttons__XOui2"};